import { render, staticRenderFns } from "./PaymentSuccesful.vue?vue&type=template&id=51186048&web=true&"
import script from "./PaymentSuccesful.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccesful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports